import styled, { css, keyframes } from 'styled-components'
import colors from '../../constants/colors'
import Flex from '../Flex'

import { TabItemWrapperProps } from './Tabs.types'

const borderAnimate = keyframes`
  0% { width: 0; }
  100% { width: 100%; }
`
export const TabItemWrapper = styled(Flex)<TabItemWrapperProps>`
  box-sizing: border-box;
  padding-${(props) => props.placement}: 2px;
  cursor: pointer;
  ${(props) =>
    props.isActive &&
    css`
      &::before {
        content: '';
        position: absolute;
        left: 0;
        height: 2px;
        background-color: ${colors.blue50};
        cursor: pointer;
        -webkit-animation-name: ${borderAnimate};
        -webkit-animation-duration: 0.6s;
        animation-name: ${borderAnimate};
        animation-duration: 0.6s;
        animation-fill-mode: forwards;
      }
    `}

  &::before {
    ${(props) => props.placement}: -1px;
  }
`
